/* @ngInject */
export default function FroalaFilePopoverController(
  config,
) {
  const vm = this;
  vm.validFileTypes = config.files.allUploadableExtensions.join(', ');
}
